<template>
  <v-row no-gutters align="center" class="list-action-panel_body justify-space-between">
    <v-col class="checkbox-icon check-selecting">
      <template
        v-if="isCheckable"
      >
        <v-icon
          v-if="allChecked"
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- check_box -->
          fas fa-check-circle
        </v-icon>
        <v-icon
          v-else-if="someChecked"
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- indeterminate_check_box -->
          fas fa-minus-circle
        </v-icon>
        <v-icon
          v-else
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- check_box_outline_blank -->
          far fa-circle
        </v-icon>
      </template>
      <span v-if="checkedOnPageCount > 0" class="pt-2">{{$t('general.selected')}}: {{checkedOnPageCount}}</span>
      <div class="list-action-panel_actions">
        <v-tooltip bottom
          v-for="(action, index) in actions"
          :key="index"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dense
              depressed
              v-on="on"
              @click="action.callback()"
              icon
              :loading="action.loading"
            >
              <v-icon color="#757575">
                {{action.icon}}
              </v-icon>
            </v-btn>
          </template>
          <span>{{action.tooltip}}</span>
        </v-tooltip>
        <slot name="extraButtons"></slot>
      </div>
    </v-col>
    <!-- <v-col v-if="checkedOnPageCount > 0" cols="2">
      <span>Selected: {{checkedOnPageCount}}</span>
    </v-col> -->
    <!-- <div class="list-action-panel_actions">
        <v-tooltip bottom
          v-for="(action, index) in actions"
          :key="index"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="action.callback()"
              icon medium
              :loading="action.loading"
            >
              <v-icon color="#757575">
                {{action.icon}}
              </v-icon>
            </v-btn>
          </template>
          <span>{{action.tooltip}}</span>
        </v-tooltip>
        <slot name="extraButtons"></slot>
    </div> -->
    <div class="pagination pr-4">
      <span>{{pageResultsPagination.pageStart | filterIsNaN}} - {{pageResultsPagination.pageEnd | filterIsNaN}} {{$t('general.of')}} {{pageResultsPagination.numOfAllHits | filterIsNaN}}</span>
      <ais-pagination style="text-align: center;">
        <div
          slot-scope="{
            currentRefinement,
            pages,
            isFirstPage,
            isLastPage,
            refine,
          }"
          class="pagination_list"
          v-show="pages.length > 1"
        >
          <v-btn
            fab depressed
            :disabled="isFirstPage"
            @click="refine(currentRefinement - 1); changeListPage(currentRefinement - 1)"
          >
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <v-btn
            fab depressed
            :disabled="isLastPage"
            @click="refine(currentRefinement + 1); changeListPage(currentRefinement + 1)"
          >
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </div>
      </ais-pagination>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectHits } from 'instantsearch.js/es/connectors/'

export default {
  name: 'ListActionPanel',
  components: {},
  mixins: [
    createWidgetMixin({ connector: connectHits })
  ],
  props: {
    actions: Array,
    isCheckable: { type: Boolean, default: true }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['getActualListPage', 'getCheckedOnPageCount', 'getCheckedOnPage']),
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    },
    checkedOnPage () {
      return this.getCheckedOnPage(this.actualPage)
    },
    actualPage () {
      return this.getActualListPage
    },
    allChecked () {
      return this.checkedOnPageCount === this.hitsOnPage.length
    },
    someChecked () {
      return this.checkedOnPageCount > 0 && this.checkedOnPageCount < this.hitsOnPage.length
    },
    algoliaState () {
      if (this.state !== null) {
        return this.state
      } else {
        return {
          hits: [],
          results: {
            page: 0
          }
        }
      }
    },
    hitsOnPage () {
      for (let i = 0; i < this.algoliaState.hits.length; i++) {
        this.algoliaState.hits[i].id = this.algoliaState.hits[i].objectID
      }
      // console.log(this.algoliaState)
      return this.algoliaState.hits
    },
    pagination () {
      const pagination = {
        actualPage: this.algoliaState.results.page,
        hitsPerPage: this.algoliaState.results.hitsPerPage,
        numOfAllHits: this.algoliaState.results.nbHits
      }
      return pagination
    },
    pageResultsPagination () {
      if (this.pagination.numOfAllHits === 0) {
        return ''
      }
      // const conjunction = this.$i18n.t('general.of')
      const pageStart = this.pagination.actualPage * this.pagination.hitsPerPage + 1
      let pageEnd = this.pagination.actualPage * this.pagination.hitsPerPage + this.pagination.hitsPerPage
      if (pageEnd > this.pagination.numOfAllHits) {
        pageEnd = this.pagination.numOfAllHits
      }
      return { pageStart, pageEnd, numOfAllHits: this.pagination.numOfAllHits }
    }
  },
  methods: {
    ...mapActions({ toggleCheckAll: 'toggleCheckAll', changeListPage: 'changeListPage' }),
    handleToggleCheckAll () {
      this.toggleCheckAll({ page: this.actualPage, hitsOnPage: this.hitsOnPage })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-action-panel_body {
    height: 100%;
    // padding-left: 24px;
  }
  .check-selecting {
    display: inline-flex;
    span, .v-col {
      color: #757575;
      font-weight: 500;
      padding-top: 2px;
      display: inline-block;
      font-size: 14px;
    }
  }
  .pagination {
    span {
      display: inline-block;
    }
    .ais-Pagination {
      display: inline-block;
    }
  }
  .pagination_list {
    font-size: 18px;
    .v-btn {
      width: 25px;
      height: 25px;
      margin: 0 0 0 16px;
    }
  }
  .checkbox-icon{
    .v-icon {
      padding-left: 24px;
      padding-right: 8px;
    }
  }
</style>
